import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { MyPlatform, MyPlatformsActions } from '../actions/my-platforms.actions';
import { ApiServerService } from '../../shared/services/api-server.service';

@Injectable()
export class MyPlatformsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly apiServerService: ApiServerService,
  ) {}

  loadMyPlatforms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyPlatformsActions.loadMyPlatforms),
      mergeMap(() =>
        this.apiServerService.GET<MyPlatform[]>('platform/my').pipe(
          map((platforms) => MyPlatformsActions.loadMyPlatformsSuccess({ platforms })),
          catchError((error) => of(MyPlatformsActions.loadMyPlatformsFailure({ error }))),
        ),
      ),
    ),
  );
}
